import snakeCaseKeys from 'snakecase-keys';
import { post } from '../api';

const route = '/auth/candidates?include_set=login';

const postCandidates = ({ data, config }) =>
  post(route, snakeCaseKeys(data, { deep: true }), config);

export default postCandidates;
